import axios from "axios";
import { config } from "../config";
import { calendarFunctions } from "../helpers/calendar-functions";

const API_URL = config.API_URL;

const getAllEvents = (sort = '') => {
    
    const payload = {
        sort,
        sortKey: (JSON.parse(localStorage.getItem('user'))).sortKey
    };

    return axios.post(`${API_URL}allevents`, payload);
}

const getWeatherByLocation= (city) => {
    const payload = {
        city: city
    }
    return axios.post(`${API_URL}getweatherbylocation `, payload);
}

const putEvents = ({sortKey, email, events, create = false, viewSortKey = undefined, isReminder = undefined}) => {
    if (create) {
        events = [{
            ...events[0],
            sortKey
        }]
    } else {
        events = calendarFunctions.filterEventsBySortKey(events, sortKey);
    }
    const payload = {
        sortKey,
        email,
        events,
        create,
        viewSortKey,
        isReminder
    }

    return axios.put(`${API_URL}allevents`, payload);
}

export default {
    getAllEvents,
    putEvents,
    getWeatherByLocation
}